import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/referrals',
    component: Layout,
    redirect: '/referrals/index',
    meta: {
      title: '转诊申请',
      keepAlive: true,
      requiresAuth: true,
      auth: ['referral']
    },
    children: [
      {
        path: 'index',
        name: 'ReferralsIndex',
        component: () => import('@/views/app/referrals/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '转诊申请',
        }
      }
    ]
  }
]

export default router
